<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'paineisCrud'"
          crudName="Paineis"
          newText="Novo Painel"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableDownloadPdf="true"
          :enableDownloadExcel="true"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableActive="true"
          :enableView="true"
          :enableReset="false"
          :enableSenhaPath="false"
          :enableAccessItem="true"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "paineisTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: ["id", "nome", "setores_painel", "mensagem", "actions"],
      tableData: ["id", "nome", "setores_painel", "mensagem"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "nome"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          nome: "Nome",
          setores_painel: "Setores",
          mensagem: "mensagem",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "paineis/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        nome: "nome"
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>